// extracted by mini-css-extract-plugin
module.exports = {"dismissButton":"_1aAUA","cardTag":"_36dVX","cardMaring":"sl0lD","handleButton":"_1lepn"};